/** 来源：foodbuy/market Field；统一 label、控件与可选 hint / 校验错误。T11 吸收 crm FormField 的 a11y 自动接线（id / aria-describedby / aria-invalid）。 */
import { cloneElement, isValidElement, useId, type ReactNode } from 'react'

type A11yControlProps = { id?: string; 'aria-describedby'?: string; 'aria-invalid'?: boolean }

export function Field({
  label,
  hint,
  error,
  required = false,
  className = '',
  children
}: {
  label: ReactNode
  hint?: ReactNode
  error?: ReactNode
  required?: boolean
  className?: string
  children: ReactNode
}) {
  const autoId = useId()
  const noteId = `${autoId}-note`
  // 单子元素控件自动接线；控件自己带过 id / aria 时不覆盖。多子元素（如复合控件组）原样渲染，由调用方自理 aria。
  const control = isValidElement<A11yControlProps>(children)
    ? cloneElement(children, {
        id: children.props.id ?? autoId,
        'aria-describedby': children.props['aria-describedby'] ?? (hint || error ? noteId : undefined),
        'aria-invalid': children.props['aria-invalid'] ?? (error ? true : undefined)
      })
    : children
  return (
    <label className={`flex flex-col gap-1 text-sm ${className}`.trim()}>
      <span className="flex items-baseline justify-between gap-2 text-xs font-medium text-[var(--color-ink)]">
        <span>
          {required ? <span className="mr-0.5 text-[var(--color-danger)]" aria-hidden="true">*</span> : null}
          {label}
        </span>
        {hint && !error ? <span id={noteId} className="text-[11px] font-normal text-[var(--color-faint)]">{hint}</span> : null}
      </span>
      {control}
      {error ? <span id={noteId} className="text-[11px] font-normal text-[var(--color-danger)]">{error}</span> : null}
    </label>
  )
}
